import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { useFormState } from 'react-final-form';
import Icon from 'src/common/components/IconDS22';
import { TripCartFormState } from 'src/listing/types';
import { useTripCartOptionsContext } from 'src/trip-cart-deprecated/hooks/useTripCartOptionsContext';
import styles from './DurationItem.module.scss';

const DurationItem: FC = () => {
  const [t] = useTranslation('listing-page');
  const { values: { formDuration } } = useFormState<TripCartFormState>();
  const { options } = useTripCartOptionsContext();
  const { formDuration: durations } = options;
  const option = durations.find((item) => item.durationFormatted === formDuration);

  if (!option) {
    return null;
  }
  return (
    <div className={styles.root}>
      {option.isInstabook && <Icon id="instabook-filled" size="s" />}
      {t(`trip-cart--duration-${option.unit}`, { duration: option.duration, count: option.duration })}
      <Icon id="caret-right" size="s" />
    </div>
  );
};

export default DurationItem;
